import Swiper, { Navigation, Lazy } from "swiper"
import { gsap } from "gsap"

export default class ServicesSlider {
  constructor (el) {
    this.el = el
    this.slider = null
    this.slides = this.el.querySelectorAll('.swiper-slide')
    this.container = this.el.closest('.m-services__slider')
    this.next = this.container.querySelector('.swiper-controls__btn--next')
    this.prev = this.container.querySelector('.swiper-controls__btn--prev')

    this.counter = this.container.querySelector('.m-services__counter')
    this.counterVal = this.container.querySelector('.m-services__counter-value')
    this.counterTotal = this.container.querySelector('.m-services__counter-total')

    this.pageWidth = window.innerWidth || document.body.clientWidth;
    this.treshold = Math.max(1,Math.floor(0.01 * (this.pageWidth)));
    this.touchstartX = 0;
    this.touchstartY = 0;
    this.touchendX = 0;
    this.touchendY = 0;

    this.limit = Math.tan(45 * 1.5 / 180 * Math.PI);

    this.slideNextHandler = (e) => this.slideNext(e)
    this.slidePrevHandler = (e) => this.slidePrev(e)

    this.isAnimate = false
    this.isMobile = false
  }

  init () {
    if (window.innerWidth < 768) {
      this.initMobileSlider()
    } else {
      this.initDesktopSlider()
    }

    setTimeout(() => {
      this.setCounter()
      this.prev.classList.add('swiper-button-disabled')
      this.initEvents()
    }, 0)

    setTimeout(() => {
      this.el.classList.remove('no-transitions')
    }, 600)
  }

  udpateSlider () {
    if (window.innerWidth < 768) {
      if (this.isMobile) return;
      this.destroy()
      this.isMobile = true
      this.initMobileSlider()
    } else {
      if (!this.isMobile) return;
      this.destroy()
      this.isMobile = false
      this.initDesktopSlider()
    }
  }

  destroy () {
    if (!this.slider) return;
    this.slider.destroy()
    this.slider = null
  }

  initDesktopSlider () {
    if (this.slider) return;
    this.slider = new Swiper(this.el, {
      modules: [ Navigation, Lazy ],
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
      },
      slidesPerView: 1,
      spaceBetween: 40,
      speed: 900,
      loop: true,
      roundLengths: true,
      loopAdditionalSlides: this.slides.length,
      simulateTouch: false,
      allowTouchMove: false,
    })
  }

  initMobileSlider () {
    if (this.slider) return;
    this.slider = new Swiper(this.el, {
      modules: [ Navigation, Lazy ],
      preloadImages: false,
      lazy: {
        loadPrevNext: false,
        loadOnTransitionStart: true
      },
      slidesPerView: 1,
      spaceBetween: 40,
      observer: true,
      observeParents: true,
      loop: true,
      roundLengths: true,
      loopAdditionalSlides: this.slides.length,
      autoHeight: true,
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      on: {
        'transitionEnd': () => {
          this.setCounter()
        }
      }
    })
  }

  setCounter () {
    if (!this.slider) return;
    this.counterVal.innerHTML = (this.slider.realIndex + 1).toString().padStart(2, '0')
    this.counterTotal.innerHTML = ` / ${this.slides.length.toString().padStart(2, '0')}`
  }

  initEvents () {
    this.next.addEventListener('click', e => {
      if (window.innerWidth < 768) return;
      e.preventDefault()
      this.slideNextHandler(e)
    })
    this.prev.addEventListener('click', e => {
      if (window.innerWidth < 768) return;
      e.preventDefault()
      this.slidePrevHandler(e)
    })

    this.el.addEventListener('touchstart', e => {
      if (window.innerWidth < 768) return;
      this.touchstartX = e.changedTouches[0].screenX;
      this.touchstartY = e.changedTouches[0].screenY;
    }, false);
    
    this.el.addEventListener('touchend', e => {
      if (window.innerWidth < 768) return;
      this.touchendX = e.changedTouches[0].screenX;
      this.touchendY = e.changedTouches[0].screenY;
      this.handleSwipeDirection(e);
    }, false);

    window.addEventListener('resize', e => this.udpateSlider())

  }

  handleSwipeDirection (e) {
    let x = this.touchendX - this.touchstartX;
    let y = this.touchendY - this.touchstartY;
    let xy = Math.abs(x / y);
    let yx = Math.abs(y / x);
    if (Math.abs(x) > this.treshold || Math.abs(y) > this.treshold) {
        if (yx <= this.limit) {
            if (x < 0) {
              console.log("left");
              this.slideNext()
              } else {
                console.log("right");
                this.slidePrev()
            }
        }
    } else {
        console.log("tap");
    }
  }

  slideNext () {
    console.log(this.slider.activeIndex)
    let index = this.slider.realIndex + 1
    if (index === this.slides.length) return;
    
    
    const slideActive = this.el.querySelector('.swiper-slide-active')
    const captionActive = slideActive.querySelector('.services-slider__caption')
    const slideNext = this.el.querySelector('.swiper-slide-next')
    const captionNext = slideNext.querySelector('.services-slider__caption')
    const staggerItems = captionNext.querySelectorAll('.js-stagger-item')
    const allStagerItems = this.el.querySelectorAll('.js-stagger-item')
    
    
    if (this.isAnimate) return;
    this.prev.classList.remove('swiper-button-disabled')
    this.isAnimate = true
    gsap.fromTo(captionActive,
      {
        opacity: 1,
        y: 0
      },
      {
        opacity: 0,
        y: 20,
        duration: 0.6,
        ease: 'ease',
        onStart: () => {
          gsap.set(captionActive, { transition: 'none' })
          gsap.set(captionNext, { transition: 'none' })
        },
        onComplete: () => {
          gsap.set(allStagerItems, { opacity: 0 })
          this.slider.slideToLoop(index)
          gsap.set(captionActive, { y: 0 })
          gsap.set(captionNext, { y: 0, opacity: 1 })
          if (this.slider.realIndex + 1 === this.slides.length) {
            this.next.classList.add('swiper-button-disabled')
          }
          this.setCounter()
        }
      }
    )

    this.slider.on('slideChangeTransitionEnd', e => {
      gsap.fromTo(staggerItems, 
        {
          opacity: 0,
          y: 20
        }, 
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          stagger: 0.15,
          ease: 'ease',
          onComplete: () => {
            this.isAnimate = false
          }
        }
      )
    })

  }
  
  slidePrev () {
    const index = this.slider.realIndex

    if (index === 0) return;

    
    const slideActive = this.el.querySelector('.swiper-slide-active')
    const captionActive = slideActive.querySelector('.services-slider__caption')
    const slidePrev = this.el.querySelector('.swiper-slide-prev')
    const captionPrev = slidePrev.querySelector('.services-slider__caption')
    const staggerItems = captionPrev.querySelectorAll('.js-stagger-item')
    const allStagerItems = this.el.querySelectorAll('.js-stagger-item')
    
    if (this.isAnimate) return;
    this.next.classList.remove('swiper-button-disabled')
    this.isAnimate = true
    gsap.fromTo(captionActive,
      {
        opacity: 1,
        y: 0
      },
      {
        opacity: 0,
        y: 20,
        duration: 0.6,
        ease: 'ease',
        onStart: () => {
          gsap.set(captionActive, { transition: 'none' })
          gsap.set(captionPrev, { transition: 'none' })
        },
        onComplete: () => {
          this.slider.slideToLoop(index - 1)
          gsap.set(allStagerItems, { opacity: 0 })
          gsap.set(captionActive, { y: 0 })
          gsap.set(captionPrev, { y: 0, opacity: 1 })
          if (this.slider.realIndex === 0) {
            this.prev.classList.add('swiper-button-disabled')
          }
          this.setCounter()
        }
      }
    )

    this.slider.on('slideChangeTransitionEnd', e => {
      gsap.fromTo(staggerItems, 
        {
          opacity: 0,
          y: 20
        }, 
        {
          opacity: 1,
          y: 0,
          duration: 0.3,
          stagger: 0.15,
          ease: 'ease',
          onComplete: () => {
            this.isAnimate = false
          }
        }
      )
    })

  }
}
